// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var SectionStatus = function (x) {
    return x;
};
var tsBridgeSectionStatus = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("SectionStatus")("__brandSectionStatus"));
    }
};
var writeSectionStatus = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showSectionStatus = Data_Show.showString;
var readSectionStatus = Simple_JSON.readString;
var ordSectionStatus = Data_Ord.ordString;
var newtypeSectionStatus = {
    Coercible0: function () {
        return undefined;
    }
};
var makeSectionStatus = SectionStatus;
var eqSectionStatus = Data_Eq.eqString;
export {
    SectionStatus,
    makeSectionStatus,
    unwrap,
    newtypeSectionStatus,
    eqSectionStatus,
    ordSectionStatus,
    showSectionStatus,
    readSectionStatus,
    writeSectionStatus,
    tsBridgeSectionStatus
};
//# sourceMappingURL=index.js.map
